import { css } from '@emotion/react';
import styled from '@emotion/styled';
import TrashIcon from '@/assets/icons/trash.svg?react';
import WarningIcon from '@/assets/icons/warning.svg?react';

export const RemoveMessageIcon = styled(TrashIcon)`
  width: 100%;
  height: 100%;
  color: #f44336;
`;

export const RemoveMessageIconWrapper = styled.button`
  position: absolute;
  top: -4px;
  right: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 6px;
  cursor: pointer;
  border: none;
  border-radius: 50%;
  background: none;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
  z-index: 1;
  transition: all 0.3s ease;

  &:hover {
    scale: 1.1;
  }
`;

export const WarningDescriptionIcon = styled(WarningIcon)`
  margin-right: 4px;
  width: 18px;
  height: 18px;
  color: #ff9800;
`;

export const WarningDescription = styled.p`
  display: flex;
  align-items: center;
  color: #868383;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.2px;
  animation: ${({ theme }) => theme.animation.bubble.show} 0.15s ease-out both;
`;

export const LiveAgentMessageRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const LiveAgentContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const AgentAvatar = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding-top: 2px;
  color: #193b1d;
  line-height: 100%;
  font-size: 12px;
  font-weight: 600;
  border-radius: 50%;
  background-color: #d5e8a0;
`;

export const AgentNameTag = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 2px;
  color: #fff;
  line-height: 12px;
  font-size: 10px;
  font-weight: 400;
  border-radius: 8px 8px 0 0;
  background-color: #306336;
  gap: 4px;

  &::before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #fff;
  }
`;

export const MessageContainer = styled.li<{ isUserMessage: boolean; isSystemMessage: boolean; hasFailed?: boolean }>`
  display: flex;
  flex-direction: column;
  will-change: transform;
  transform: translateY(10px);
  animation: ${({ theme }) => theme.animation.bubble.show} 0.15s ease-out both;

  ${({ isUserMessage, isSystemMessage }) =>
    isUserMessage
      ? css`
          align-items: flex-end;
        `
      : isSystemMessage
        ? css`
            align-items: center;
          `
        : css`
            align-items: flex-start;
          `}

  ${({ hasFailed }) =>
    hasFailed &&
    css`
      cursor: pointer;
    `};
`;

export const MessagesContainer = styled.ul<{ hasChatFeedback: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 8px;
  padding: 10px 16px;
  overflow: auto;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
  transition: opacity 0.2s ease;
  will-change: auto;
  gap: 10px;

  &::after {
    content: '';
    flex: 1;
  }

  ${({ theme }) => theme.messages.styles};

  ${({ theme }) => css`
    @media (${theme.mediaMobile}) {
      ${theme.messages.mobile};
    }
  `}

  ${({ theme }) => css`
    @media not (${theme.mediaMobile}) {
      ${theme.messages.desktop};
    }
  `};
`;
